/**
 * Rule Build feature auto-registration and exports
 *
 * This module automatically registers the rule-build feature when imported,
 * making it work seamlessly with both static and dynamic imports.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { ruleBuildFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(ruleBuildFeature);

// Export store (all store-related exports)
export * from './store';

// Export hooks
export * from './hooks';

// Export types
export * from './types';

// Export constants
export * from './constants';

// Export routes
export { RuleBuildPage } from './routes';

// Export components
export * from './components';
